
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host{
  display:flex;
  position:absolute;
  left:0;
  right:0;
  background:var(--outline-white);
  padding-top:30px;
  padding-bottom:30px;
  z-index:200;
}

@media (min-width: 1024px){
  :host{
    position:inherit;
    padding-top:0;
    padding-bottom:0;
  }
}
`;